const axios = require('axios');

const ENV = process.env;

export default class ForgotPasswordService {
  static post(userInfo) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'POST',
        url: ENV.api + '/users/forgot_password',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: $.param(userInfo),
      })
        .then(function (data) {
          resolve(data);
        })
        .catch(function (data) {
          reject(data.response.data);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/forgotpassword.es6.js